import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/TikTokLogo.svg'
import _imports_1 from '../../assets/GoogleLogo.svg'


const _hoisted_1 = { class: "home_wrapper" }
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "platform_item" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "header tiktok" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_7 = { class: "platform_item" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "header google" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1)
const _hoisted_9 = { class: "wrapper" }
const _hoisted_10 = { class: "title" }
const _hoisted_11 = { class: "container" }
const _hoisted_12 = { class: "platform_item" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "header tiktok" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_14 = { class: "platform_item" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "header google" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1)

import { useJump } from '@/hooks/useJump';
  
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

  const { jumpToOpenAccountManageApply, jumpToOpenAccountManageSubmitRechargeApply } = useJump();

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_svg_icon, { "icon-name": "WE_UserAccountOutlined" }),
        _createTextVNode(" 开户 ")
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_a_card, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(jumpToOpenAccountManageApply)('TikTok')))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _hoisted_6,
                _createElementVNode("div", null, [
                  _createVNode(_component_a_button, {
                    type: "link",
                    style: {"padding-left":"0"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 点击提交开户申请 "),
                      _createVNode(_component_svg_icon, { "icon-name": "RightOutlined" })
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_a_card, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(jumpToOpenAccountManageApply)('Adwords')))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _hoisted_8,
                _createElementVNode("div", null, [
                  _createVNode(_component_a_button, {
                    type: "link",
                    style: {"padding-left":"0"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 点击提交开户申请 "),
                      _createVNode(_component_svg_icon, { "icon-name": "RightOutlined" })
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_svg_icon, { "icon-name": "WE_RMBSyncDotsOutlined" }),
        _createTextVNode(" 充值 ")
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_a_card, {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(jumpToOpenAccountManageSubmitRechargeApply)('', 'TikTok')))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _hoisted_13,
                _createElementVNode("div", null, [
                  _createVNode(_component_a_button, {
                    type: "link",
                    style: {"padding-left":"0"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 点击提交充值申请 "),
                      _createVNode(_component_svg_icon, { "icon-name": "RightOutlined" })
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_a_card, {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(jumpToOpenAccountManageSubmitRechargeApply)('', 'Adwords')))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _hoisted_15,
                _createElementVNode("div", null, [
                  _createVNode(_component_a_button, {
                    type: "link",
                    style: {"padding-left":"0"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 点击提交充值申请 "),
                      _createVNode(_component_svg_icon, { "icon-name": "RightOutlined" })
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})